import { createActionGroup, props } from '@ngrx/store';

import { chartingStateKey } from './charting.state-key';

export const chartingActions = createActionGroup({
  source: chartingStateKey,
  events: {
    LastToothPositionChanged: props<{ toothPosition: number | undefined }>(),
    ParamsChanged: props<{ siteId: string; patientId: string; examCount: number; silentReload: boolean }>(),
    ScreenChanged: props<{ screen: 'charting' | 'perio' }>(),
    ViewToggleChanged: props<{ viewToggle: 'charting' | 'perio' }>(),
  },
});
